import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatSlideToggleChange as MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Moment } from 'moment';
import { Filter } from '@huge-monorepo/hip/domain';
import { GraphChange } from '@huge-monorepo/hip/domain';
import { TimeFrame } from '@huge-monorepo/hip/domain';
import { TimePeriod } from '@huge-monorepo/hip/domain';
import { ToolsService } from '@huge-monorepo/hip/services';
import { GenericGraphComponent } from '../generic-graph/generic-graph.component';

@Component({
  selector: 'app-generic-graph-handler',
  templateUrl: './generic-graph-handler.component.html',
  styleUrls: ['./generic-graph-handler.component.scss'],
})
export class GenericGraphHandlerComponent implements OnInit {
  @ViewChild('GraphChild', { static: false }) public GraphChild: GenericGraphComponent;
  @ViewChildren('GraphChildren') public GraphChildren: QueryList<GenericGraphComponent>;

  @Output() changed: EventEmitter<GraphChange> = new EventEmitter<GraphChange>();
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();
  @Input() graphData: GraphChange;
  @Input() enableDataLabels: boolean;
  @Input() showTimeFilter: boolean = true;
  @Input() showDaterangeSelector: boolean = true;
  @Input() showDaySelector: boolean = false;
  @Input() showDatepickerToggle: boolean = false;
  @Input() showTableViewToggle: boolean = false;
  @Input() showRefresh: boolean = true;
  @Input() onlyDayFilter: boolean = false;
  @Input() isFormatted = false;
  @Input() enableDataPoints: boolean = false;
  @Input() showToolBar: boolean = true;

  TimeFilters: Filter[];
  selectedInterval: Filter;

  noData: boolean = false;
  @Input() height: any;
  graphNames: any;
  element: HTMLElement;
  tableViewChecked: false;

  constructor(private detector: ChangeDetectorRef, private tools: ToolsService) {}

  ngOnInit() {
    if ((this.showDatepickerToggle && !this.graphData.Variables['dayFilter']) || this.onlyDayFilter) {
      this.showDaySelector = true;
      this.showDaterangeSelector = false;
    } else if (this.showDatepickerToggle && this.graphData.Variables['dayFilter']) {
      // This is needed otherwise dates jump due to timezone offset
      this.graphData.EndDate = new Date(this.graphData.EndDate.getFullYear(), this.graphData.EndDate.getMonth(), this.graphData.EndDate.getDate() - 1);

      this.showDaySelector = false;
      this.showDaterangeSelector = true;
    }
    this.graphData.Callback = this.transformAndPopulate;
    this.graphData.GraphHandler = this;
  }

  ngAfterViewInit(): void {
    this.transformAndPopulate(this.graphData);
    this.detector.detectChanges();
  }

  updateSelectedTimeFilter(eve) {
    this.graphData.Interval = eve;
    this.emitToParent();
  }

  updateDates(returnedDates: any) {
    this.graphData.StartDate = this.tools.ParseAPIDate(returnedDates.startDate);
    this.graphData.EndDate = this.tools.ParseAPIDate(returnedDates.endDate);
  }

  timeFrameSelected(timeFrame: TimeFrame) {
    this.graphData.TimeFrame = timeFrame;
    this.emitToParent();
  }

  timePeriodSelected(timePeriod) {
    this.graphData.Timeperiod = timePeriod;
    this.emitToParent();
  }

  emitToParent() {
    if (this.graphData.IsMulti) {
      this.GraphChildren.toArray().forEach((e) => {
        e.setGraphLoading();
      });
      this.changed.emit(this.graphData);
    } else {
      this.GraphChild.setGraphLoading();
      this.changed.emit(this.graphData);
    }
  }

  intervalInputChanged(interval: number) {
    this.graphData.Interval = interval;
    this.emitToParent();
  }

  transformAndPopulate(c: GraphChange) {
    if (this.isFormatted) {
      c.GraphHandler.GraphChild.setGraphData(c);
      this.graphData = c;
    } else {
      if (c && c.IsMulti) {
        if (c.UnprocessedData != null) {
          this.noData = false;
          this.graphNames = Object.keys(c.UnprocessedData);
          let count: number = 0;
          let temp = c.UnprocessedData;
          if (c.GraphHandler.GraphChildren.toArray().length == 0) {
             c.GraphHandler.GraphChildren.changes.subscribe((comps: QueryList<GenericGraphComponent>) => {
              comps.forEach((e) => {
                c.UnprocessedData = temp[this.graphNames[count]];
                c.Transformer(c);
                e.setGraphData(c);
                count++;
              });
              c.UnprocessedData = temp;
            });
          } else {
            c.GraphHandler.GraphChildren.toArray().forEach((e) => {
              c.UnprocessedData = temp[this.graphNames[count]];
              c.Transformer(c);
              e.setGraphData(c);
              count++;
              c.UnprocessedData = temp;
            });
          }
        } else {
          this.noData = true;
        }
      } else {
        if (c.UnprocessedData != null) {
          c.Transformer(c);
          c.GraphHandler.GraphChild.setGraphData(c);
          this.graphData = c;
          this.noData = false;
        } else {
          this.noData = true;
        }
      }
    }
  }

  notify(ev) {
    if (this.selected != null) {
      this.selected.emit(ev);
    }
  }

  refreshGraph(c) {
    c.GraphChild.setGraphLoading();
  }

  viewChanged() {
    if (!this.tableViewChecked) {
      this.transformAndPopulate(this.graphData);
      this.detector.detectChanges();
    }
  }

  toggleDatepicker(ev: MatSlideToggleChange) {
    this.graphData.Variables['dayFilter'] = ev.checked;
    if (ev.checked) {
      // This is needed otherwise dates jump due to timezone offset
      this.graphData.EndDate = new Date(this.graphData.EndDate.getFullYear(), this.graphData.EndDate.getMonth(), this.graphData.EndDate.getDate() - 1);
      this.showDaterangeSelector = true;
      this.showDaySelector = false;
    } else {
      this.graphData.StartDate = this.tools.GetStartOfDay(this.graphData.StartDate);
      this.graphData.EndDate = this.tools.GetEndOfDay(this.graphData.StartDate);

      this.showDaterangeSelector = false;
      this.showDaySelector = true;
    }
  }

  dayPickerChanged(ev: Moment) {
    var d = new Date(ev.year(), ev.month(), ev.date());
    this.graphData.StartDate = this.tools.GetStartOfDay(d);
    this.graphData.EndDate = this.tools.GetEndOfDay(d);
  }
}
